import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#e5e5e5] bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="font-brand text-3xl leading-none">K-Walk</div>
          <p className="text-sm text-[#666] mt-4 leading-relaxed">
            Handcrafted footwear since 2011.<br />Exclusively at B.K. Shoe, Agra.
          </p>
          <p className="text-xs text-[#666] mt-4 leading-relaxed">
            <a href="mailto:km.international19@gmail.com" className="hover:text-black" data-testid="footer-email">
              km.international19@gmail.com
            </a>
            <br />
            <a href="tel:+917302209481" className="hover:text-black" data-testid="footer-phone">
              +91 73022 09481
            </a>
          </p>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Shop</div>
          <ul className="text-sm space-y-2 text-[#111]">
            <li><Link to="/shop" className="hover:opacity-70">All Shoes</Link></li>
            <li><Link to="/shop?category=loafers" className="hover:opacity-70">Loafers</Link></li>
            <li><Link to="/shop?category=chelsea" className="hover:opacity-70">Chelsea Boots</Link></li>
            <li><Link to="/shop?category=wedding" className="hover:opacity-70">Wedding</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Help</div>
          <ul className="text-sm space-y-2 text-[#111]">
            <li><Link to="/refund" className="hover:opacity-70" data-testid="footer-shipping-link">Shipping</Link></li>
            <li><Link to="/refund" className="hover:opacity-70" data-testid="footer-returns-link">Returns &amp; Refunds</Link></li>
            <li><Link to="/contact" className="hover:opacity-70" data-testid="footer-contact-link">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Legal</div>
          <ul className="text-sm space-y-2 text-[#111]">
            <li><Link to="/terms" className="hover:opacity-70" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:opacity-70" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:opacity-70" data-testid="footer-refund-link">Refund Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#e5e5e5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="text-xs text-[#666] flex flex-wrap gap-3">
            {["UPI", "GPay", "PhonePe", "Paytm", "Visa", "Mastercard", "RuPay", "Net Banking"].map(
              (m) => (
                <span
                  key={m}
                  className="uppercase tracking-widest text-[10px] border border-[#e5e5e5] px-2 py-1"
                >
                  {m}
                </span>
              ),
            )}
          </div>
          <span className="text-xs text-[#666]">
            © {new Date().getFullYear()} K-Walk · Handcrafted in India
          </span>
        </div>
      </div>
    </footer>
  );
}
